const styles = theme => ({
  accordianFrame: {
    [theme.breakpoints.up('md')]: {
      border: '1px solid #CED1D6',
    },
    margin: ' 0 0 5px !important',
    overflow: 'hidden',
    color: '#342D3D',
    '&:before': {
      background: 'transparent',
      display: 'none',
    },
  },
  expandedaccordianFrame: {
    [theme.breakpoints.up('md')]: {
      borderRadius: '0px !important',
    },
  },
  accTitleHead: {
    background: '#F8F8F8',
    color: '#342D3D',
    padding: '4px 15px',
    '& > div': {
      margin: '0 !important',
    },
    '& $heading': {
      fontSize: '16px',
      fontWeight: '600',
    },
    '& svg': {
      color: '#342D3D',
      fontSize: '27px',
    },
  },
  heading: {},
  accordionDetails: { padding: '0', flexDirection: 'column' },

  '@media (min-width: 768px)': {
    accTitleHead: {
      padding: '4px 24px',
      '& $heading': {
        fontSize: '20px',
      },
      '& svg': {
        fontSize: '27px',
      },
    },
    accordianFrame: { margin: '0 0 16px !important' },
    occupantsGridsect: {
      margin: '-12px -30px',
      '& $griditem': {
        padding: '8px 20px',
      },
    },
    firstpartyGridsect: {
      margin: '0 -30px',
      width: 'calc(100% + 60px)',
    },
  },
  '@media (max-width: 767px)': {
    accTitleHead: {
      minHeight: '48px !important',
      '& > div': {
        padding: '0',
      },
    },
  },
});

export default styles;
